import { TranscriptionScopeFilter } from "@/graphql/generated/graphql";
import { Setterize, ValueWrapper } from "@/helpers/types/types.helpers";

type TranscriptionScopeFilterValue = Omit<
  Partial<TranscriptionScopeFilter>,
  "searchContent"
> & {
  // "searchContent" is mandatory.
  searchContent: TranscriptionScopeFilter["searchContent"];
};

type TranscriptionScopeBuildType = Setterize<TranscriptionScopeFilter>;

export class TranscriptionScopeBuilder
  implements
    TranscriptionScopeBuildType,
    ValueWrapper<TranscriptionScopeFilterValue>
{
  value: TranscriptionScopeFilterValue;

  constructor() {
    this.value = {
      searchContent: "",
    };
  }

  unwrap() {
    return this.value;
  }

  setAgents(agentsFilter: TranscriptionScopeFilter["agents"]) {
    this.value.agents = agentsFilter;
    return this;
  }

  setEndTime(endTimeFilter: TranscriptionScopeFilter["endTime"]) {
    this.value.endTime = endTimeFilter;
    return this;
  }

  setLimit(limitFilter: TranscriptionScopeFilter["limit"]) {
    this.value.limit = limitFilter;
    return this;
  }

  setPhoneNumbers(
    phoneNumbersFilter: TranscriptionScopeFilter["phoneNumbers"]
  ) {
    this.value.phoneNumbers = phoneNumbersFilter;
    return this;
  }

  setSearchContent(
    searchContentFilter: TranscriptionScopeFilter["searchContent"]
  ) {
    this.value.searchContent = searchContentFilter;
    return this;
  }

  setStartTime(startTimeFilter: TranscriptionScopeFilter["startTime"]) {
    this.value.startTime = startTimeFilter;
    return this;
  }

  setQueryType(queryTypeFilter: TranscriptionScopeFilter["queryType"]) {
    this.value.queryType = queryTypeFilter;
    return this;
  }
}
